<template>
  <custom-dialog
    class="topic-bind-model-dialog2"
    :width="width"
    top="5vh"
    :title="model.title"
    :visible="visible"
    v-on="$listeners"
    :append-to-body="true"
  >
    <div class="dialog-body">
      <custom-tab
        :list="tabData"
        v-model="tabIndex"
      ></custom-tab>
      <edit
        v-show="tabIndex === 1"
        :topicId="topicId"
        :protocolCode="protocolCode"
        :tableHeight="editTableHeight"
        ref="editList"
      ></edit>
      <selected
        v-show="tabIndex === 0"
        :topicId="topicId"
        :protocolCode="protocolCode"
        :tableHeight="tableHeight"
        ref="selectedList"
      ></selected>
    </div>
    <div
      slot="footer"
      class="dialog-footer"
      v-if="tabIndex === 1"
    >
      <el-button @click="closeDialog">{{ $t('Common.com_cancel') }}</el-button>
      <el-button
        type="primary"
        @click="onConfirm('editList')"
      >{{ $t('Common.com_save') }}</el-button>
    </div>
    <div
      slot="footer"
      class="dialog-footer"
      v-if="tabIndex === 0"
    >
      <el-button @click="closeDialog">{{ $t('Common.com_cancel') }}</el-button>
      <el-button
        type="primary"
        @click="onConfirm('selectedList')"
      >{{ $t('Common.com_save') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

import edit from './topic_bind_model_edit.vue';
import selected from './topic_bind_model_selected.vue';

export default {
  mixins: [dialogMixins],
  components: {
    edit,
    selected,
  },
  props: {
    topicId: String,
    protocolCode: String,
    width: String,
  },
  computed: {
    tableHeight() {
      const windowHeight = window.innerHeight;
      const defaultHeight = 314;
      const dialogHeight = windowHeight * 0.9;
      const tableHeight = Math.max(400, dialogHeight - defaultHeight);
      return [tableHeight, 'px'].join('');
    },
    editTableHeight() {
      const windowHeight = window.innerHeight;
      const defaultHeight = 314;
      const dialogHeight = windowHeight * 0.9;
      const tableHeight = Math.max(400, dialogHeight - defaultHeight);
      return [tableHeight + 64, 'px'].join('');
    },
    tabData() {
      return [
        {
          name: this.$t('dms_topic_bind_model_dialog.yglwmx'),
          value: 0,
        },
        {
          name: this.$t('dms_topic_bind_model_dialog.guan_lian_wu_mo_xing'),
          value: 1,
        },
      ];
    },
  },
  data() {
    return {
      tabIndex: 0,
      provide: true,
    };
  },
  methods: {
    closeDialog() {
      this.visible = false;
    },
    onConfirm(type) {
      this.validate((val) => {
        if (val) {
          const api = type === 'editList' ? apis.TopicAssociateTsl : apis.TopicEditAssociateTsl;
          this.$postJSON(api, this.getReqData(type)).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
            if (type === 'editList') {
              this.$refs.editList.clearData();
              this.tabIndex = 0;
              this.$refs.selectedList.getTableList();
            } else {
              this.$refs.selectedList.clearRecord();
              this.$refs.selectedList.getTableList();
            }
            this.$emit('success');
          });
        }
      }, type);
    },
    validate(cb, type) {
      cb = cb || function () { };
      const list = this.$refs[type].getList();
      if (!list.length) {
        const tips = this.$t('dms_topic_bind_model_dialog.qxzwmx');
        this.$message.error(tips);
        return cb(false);
      }
      return cb(true);
    },
    expandList(list) {
      const ret = [];
      list.forEach((item) => {
        ret.push(item);
        if (item.children && item.children.length) {
          ret.push(...item.children);
        }
      });
      return ret;
    },
    copy(data) {
      return JSON.parse(JSON.stringify(data));
    },
    getTslList(item) {
      return {
        tcpDataCode: item.tcpDataCode,
        tcpTslCode: item.tcpTslCode,
        topicTslClass: item.topicTslClass,
        topicTslType: item.topicTslType,
        transferExpression: item.transferExpression,
        transferType: item.transferType,
        tslDataId: item.tslDataId,
        tslId: item.tslId,
        isPrimary: item.isPrimary,
        isYearKey: item.isYearKey,
        showOrder: item.showOrder,
        topicTslDataId: item.topicTslDataId,
        tcpDataLen: item.tcpDataLen,
        tcpDataType: item.tcpDataType,
        isPushMq: item.isPushMq ? 1 : 0,
        topicTslGroup: item.topicTslGroup,
        tcpTopicTslClass: item.tcpTopicTslClass,
      };
    },
    getReqData(type) {
      if (type === 'editList') {
        const list = this.$refs[type].getList();
        const tslList = this.expandList(list).map(this.getTslList);
        return {
          topicId: this.topicId,
          tslList: this.$formatCopyUp(tslList, ['topicTslGroup', 'topicTslClass', 'tcpDataType', 'tcpTopicTslClass']),
        };
      } else {
        const list = this.$refs[type].getRecord();
        list.sort((a, b) => a.index - b.index);
        const tslList = this.expandList(list).map(this.getTslList);
        return this.$formatCopyUp(tslList, ['topicTslGroup', 'topicTslClass', 'tcpDataType', 'tcpTopicTslClass']);
      }
    },
  },
  mounted() {
  },
};
</script>

<style></style>
